/* __next_internal_client_entry_do_not_use__ ProductTileSwatches,BrandPageProductTileSwatches auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
var getOptimizedSwatchImageSrc = function(image, isSSR) {
    return optimizeImageUrl(image, isSSR, {
        width: 360,
        height: 360,
        resizeMethod: "fill",
        dprOverride: 1
    });
};
export var ProductTileSwatches = function(param) {
    var optionDetails = param.optionDetails;
    var _optionDetails_swatch_details, _optionDetails_swatch_details1;
    var isSSR = useIsSSR();
    if (!optionDetails) {
        return null;
    }
    if (optionDetails === null || optionDetails === void 0 ? void 0 : optionDetails.text) {
        return /*#__PURE__*/ _jsx(StyledTypography, {
            children: optionDetails.text
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: 2,
                    tabletAndAbove: 4
                }
            }),
            /*#__PURE__*/ _jsxs(StyledSwatchesRow, {
                children: [
                    /*#__PURE__*/ _jsx(StyledSwatchesImageRow, {
                        align: "center",
                        children: (_optionDetails_swatch_details = optionDetails.swatch_details) === null || _optionDetails_swatch_details === void 0 ? void 0 : _optionDetails_swatch_details.swatch_preview_images.map(function(image) {
                            return /*#__PURE__*/ _jsx(Image, {
                                src: getOptimizedSwatchImageSrc(image, isSSR)
                            }, image.token);
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1/2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        children: (_optionDetails_swatch_details1 = optionDetails.swatch_details) === null || _optionDetails_swatch_details1 === void 0 ? void 0 : _optionDetails_swatch_details1.formatted_remaining_option_count
                    })
                ]
            })
        ]
    });
};
/**
 * Eventually this should be a single component consuming ILeanProductTiles,
 * however on brand page we use ProductTileInfo instead.
 */ export var BrandPageProductTileSwatches = function(param) {
    var productTileInfo = param.productTileInfo;
    return /*#__PURE__*/ _jsx(ProductTileSwatches, {
        optionDetails: productTileInfo.options_details
    });
};
var StyledSwatchesImageRow = styled(Row).withConfig({
    componentId: "sc-f85a46ea-0"
})([
    "margin-left:-1px;> img:nth-child(n + 2){margin-left:-4px;}"
]);
var Image = styled.img.withConfig({
    componentId: "sc-f85a46ea-1"
})([
    "width:",
    ";border:1px solid white;height:",
    ";border-radius:100%;object-position:center;"
], getSpacing("2x"), getSpacing("2x"));
var StyledSwatchesRow = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-f85a46ea-2"
})([
    "height:20px;"
]);
var StyledTypography = styled(Typography).attrs({
    variant: "paragraphSansRegular"
}).withConfig({
    componentId: "sc-f85a46ea-3"
})([
    "line-height:20px;"
]);
